'use strict';
module.exports = '1.8.0';
